module.exports = __webpack_public_path__ + "img/wander-operate.5a8124bd.png";